<template>
    <div>
        <!-- Modal -->
        <div id="projectCommentModalNew" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header flex align-items-center">
                        <h4 class="modal-title text-lg">General Comment</h4>
                        <div class="flex align-items-center">
                            <button type="button" class="btn btn-primary border-4 rounded-full mx-2" @click="openAIProjectSummaryInfo" :disabled="researchAILoader">
                                <i v-if="researchAILoader" class="fa fa-spin fa-spinner text-white" aria-hidden="true"></i>
                                <span class="material-icons text-sm-custom text-white p-1 text-center">
                                    auto_awesome
                                </span>
                                Summarize project with AI
                            </button>
                            <button type="button" dusk="modal-close-button"
                                    class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest mx-2"
                                    data-dismiss="modal" @click="closeProjectCommentModal()">close
                            </button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <form @keydown="projectCommentForm.errors.clear($event.target.name)">
                            <div v-if="isProjectSalesStatusDead && deadReasonCustomField" class="d-flex flex-row w-full mb-3 mt-2">
                                <strong class="w-1/5 m-auto">{{ deadReasonCustomField.label_value }}: </strong>
                                <multiselect
                                    class="cursor-pointer appearance-none focus:outline-none rounded text-grey-darkest text-sm w-2/3 field-height-update"
                                    :options="deadReasonCustomField.options"
                                    v-model="projectCommentForm.deadReason"
                                    :show-labels="false"
                                    track-by="id"
                                    label="name"
                                    value="id">
                                </multiselect>
                            </div>
                            <div class="mb-2">
                                <ckeditor-container placeholder="Send your colleagues on FollowUp notifications by typing @ followed by their name" id="comment" v-model="projectCommentForm.comment" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                                <div class="text-red text-xs" v-if="projectCommentForm.errors.has('comment')">{{
                                        projectCommentForm.errors.get('comment')
                                    }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="d-flex justify-content-between w-100
">
                            <div class="snippetPopOverProjectComment">
                                <snippets-popover></snippets-popover>
                            </div>
                            <div>
                                <span v-if="this.projectCommentForm.saving">
                            <button type="button" disabled
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> Saving
                            </button>
                        </span>
                                <span v-else>
                            <button type="button" id="save-project-comment" name="save-project-comment"
                                    @click.prevent="projectCommentSaved"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                                <button type="button" v-if="projectCommentForm.id"
                                        @click.prevent="removeComment(projectCommentForm)"
                                        class="bg-red hover:bg-red-darker px-3 py-1 rounded-full text-white focus:outline-none md:hidden">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <!-- ------------------------Project Comments Section------------- -->

        <div class="spark-screen lg:container">
            <div class="rounded bg-white shadow-md spark-settings-tabs">
                <nav class="border-b-2 border-followup-nav py-1 px-3 flex align-items-baseline bg-primary text-white">
                    <div class="nav flex hidden md:inline">
                        <a class="mr-3 w-full md:w-auto text-white" :class="{'activetab' : comment_type == 'all' || comment_type == 'filters'}" @click="fetchCommentsBy('all')" href="#project_comments_tab" role="tab" data-toggle="tab" aria-controls="project_comments_tab">All</a>
                        <span class="hidden md:inline">|</span>
                        <a class="md:ml-3 w-full md:w-auto mr-3 text-white" :class="{'activetab' : comment_type == 'email'}" @click="fetchCommentsBy('email')" href="#project_comments_tab" role="tab" data-toggle="tab" aria-controls="project_comments_tab">Emails</a>
                        <span class="hidden md:inline">|</span>
                        <a class="md:ml-3 w-full md:w-auto mr-3 text-white" :class="{'activetab' : comment_type == 'comment'}" @click="fetchCommentsBy('comment')" href="#project_comments_tab" role="tab" data-toggle="tab" aria-controls="project_comments_tab">Comments</a>
                        <span class="hidden md:inline">|</span>
                        <a class="md:ml-3 w-full md:w-auto mr-3 text-white" :class="{'activetab' : comment_type == 'logs'}" @click="fetchCommentsBy('logs')" href="#project_comments_tab" role="tab" data-toggle="tab" aria-controls="project_comments_tab">Logs</a>
                        <span class="hidden md:inline">|</span>
                        <!-- <a class="md:ml-3 w-full md:w-auto mr-3 text-white" :class="{'activetab' : comment_type == 'record_detail'}" @click="fetchCommentsBy('record_detail')" href="#project_comments_tab" role="tab" data-toggle="tab" aria-controls="project_comments_tab">Record Details</a>
                        <span class="hidden md:inline">|</span> -->
                        <template v-if="!isPM">
                        <a class="md:ml-3 w-full md:w-auto mr-3 text-white" :class="{'activetab' : comment_type == 'sales_activity'}" @click="fetchCommentsBy('sales_activity')" href="#project_comments_tab" role="tab" data-toggle="tab" aria-controls="project_comments_tab">Sales Activities</a>
                        <span class="hidden md:inline">|</span>
                        <a class="md:ml-3 w-full md:w-auto mr-3 text-white" :class="{'activetab' : comment_type == 'integration'}" @click="fetchCommentsBy('integration')" href="#project_comments_tab" role="tab" data-toggle="tab" aria-controls="project_comments_tab">Integrations</a>
                        <span class="hidden md:inline">|</span>
                        </template>
                        <a class="md:ml-3 w-full md:w-auto mr-3 text-white" :class="{'activetab' : comment_type == 'milestone'}" @click="comment_type = 'milestone'" href="#project-milestones" role="tab" data-toggle="tab" aria-controls="project-milestones">Milestones</a>
                        <span class="hidden md:inline">|</span>
                    </div>
                    <div class="search-history flex">
                        <input type="text" @keyup.enter.prevent="searchComments()" v-model="comment_search" placeholder="Search project history"/>
                        <div v-if="comment_search" @click.prevent.stop="comment_search = ''; searchComments()" style="margin-left: auto;" class="align-self-center cursor-pointer text-primary" >x</div>
                        <div class="align-self-center cursor-pointer" style="margin-left: auto;">
                            <svg @click="searchComments()" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                <path d="M9.125 9.2085L11.8333 11.9168M10.4792 5.82308C10.4792 8.44068 8.35719 10.5627 5.73958 10.5627C3.12198 10.5627 1 8.44068 1 5.82308C1 3.20548 3.12198 1.0835 5.73958 1.0835C8.35719 1.0835 10.4792 3.20548 10.4792 5.82308Z" stroke="#737272" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </nav>
                <div class="tab-content justify-center">

                    <div role="tabcard" class="tab-pane active" id="project_comments_tab">

                        <div v-if="comment_loading" class="text-5xl text-grey-darkest text-center py-20">
                            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                        </div>

                        <template v-else>

                        <div class="bg-grey-light text-grey-darkest py-2 px-3 flex flex-wrap top-bar"
                            style="justify-content: space-between;">
                            <span style="align-self: center;">Filter By</span>

                            <div class="dropdown">

                                <div class="d-flex p-2 flex-row align-items-center bg-white cursor-pointer" style="gap: 40px; border-radius: 3px;" id="activityFilter" >

                                    <span>Activity ({{ filters.sales_activities.length + filters.record_details.length + filters.communication.length + filters.others.length }}/{{ (selects.sales_activities ? selects.sales_activities.length : 0 ) +15 }})</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.324554H13.1461L6.57303 5.67543L0 0.324554Z" fill="#999999"/>
                                      </svg>

                                </div>

                                <div class="dropdown-container" style="padding: 20px;" id="activityFilterDiv">
                                    <div class="d-flex flex-row">
                                        <label class=""><input type="checkbox" class="mr-2" ref="allActivityCheckbox" @click="selectAllActivitiesFilter()"><b>Select All</b></label>
                                        <span onClick="$('#activityFilterDiv').hide()" class="cursor-pointer" style="margin-left: auto;">X</span>
                                    </div>

                                    <div class="dropdown-divider"></div>

                                    <div class="d-flex flex-row" style="gap: 50px;">
                                        <div class="d-flex flex-column whitespace-no-wrap">
                                            <label class=""><input type="checkbox" class="mr-2" ref="salesActivityCheckbox" @click="selectAllSalesActivityFilter()"><b>Sales Activities</b></label>
                                            <label v-for="(activity, idx) in selects.sales_activities" style="margin-left: 10px;">
                                            <input type="checkbox" class="mr-2" v-model="filters.sales_activities" :value="activity.id">{{ activity.name }}</label>
                                        </div>
                                        <div class="d-flex flex-column whitespace-no-wrap">

                                            <label class=""><input type="checkbox" class="mr-2" ref="recordDetailCheckbox" @click="selectAllRecordDetailsFilter()"><b>Record Details</b></label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="base_bid">Base Bid</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="base_bid_total">Final Base Bid</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="contract_amount">Contract Amount</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="contract_amount_total">Final Contract Amount</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="estimated_contract_date">Estimated Contract Date</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="contract_date">Contract Date</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="login_date">Login Date</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="gross_margin_percentage">Gross Margin</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="labor_hours">Labor Hours</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="dead_date">Dead Date</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.record_details" value="complete_percentage">Completed</label>
                                            <br>
                                            <label class=""><input type="checkbox" class="mr-2" ref="communicationCheckbox" @click="selectAllCommunicationFilter()"><b>Communication</b></label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.communication" value="email">Emails</label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.communication" value="comment">Comments</label>
                                            <!-- <br>
                                            <label class=""><input type="checkbox" class="mr-2" name="" value="value"><b>Integrations</b></label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" name="" value="value">Foundation Sync</label> -->

                                        </div>
                                        <div class="d-flex flex-column whitespace-no-wrap">
                                            <label class=""><input type="checkbox" class="mr-2" ref="othersCheckbox" @click="selectAllOthersFilter()"><b>Others</b></label>
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.others" value="project_info">Project Info / Contact / Company Changes</label>
                                            <!-- <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.others" value="change_order">Change Orders Changes</label> -->
                                            <label class="" style="margin-left: 10px;"><input type="checkbox" class="mr-2" v-model="filters.others" value="project_data">Project Data Changes</label>
                                        </div>
                                    </div>

                                    <div class="dropdown-divider"></div>

                                    <button @click.prevent="applyActivityFiltersOnComments()" type="button" style="float: right;" class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">Apply & Save</button>

                                </div>
                            </div>


                            <div class="dropdown">

                                <div class="d-flex p-2 flex-row align-items-center bg-white cursor-pointer" style="gap: 40px; border-radius: 3px;" id="userFilter" >

                                    <span>Users ({{ filters.users.length }}/{{ selects.users ? selects.users.length : 0 }})</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.324554H13.1461L6.57303 5.67543L0 0.324554Z" fill="#999999"/>
                                      </svg>

                                </div>

                                <div class="dropdown-container" id="userFilterDiv">

                                    <multiselect v-if="selects.users" id="filtermultiselect" placeholder="Search Users" class="comment_filters" style="width: 220px;" v-model="filters.users" :options="selects.users" :showLabels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="name" track-by="id" :preselect-first="false">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <span class="multiselect__single" v-show="!isOpen">Users ({{ values.length || 0 }}/{{ selects.users.length }}) </span>
                                        </template>
                                        <span class="checkbox-label" slot="option" slot-scope="scope">
                                            <input :checked="isUserSelected(scope.option)" type="checkbox" @focus.prevent/>
                                            {{ scope.option.name }}
                                        </span>
                                    </multiselect>
                                    <div class="dropdown-divider"></div>
                                    <button @click.prevent="applyUserFilterOnComments()" type="button" style="float: right;" class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">Apply</button>

                                </div>
                            </div>
                            <button type="button" v-if="canEdit" id="add-comment" name="add-comment" @click.prevent.stop="addComment()"
                            class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-navv hover:text-white text-followup-nav bg-white rounded-full focus:outline-none"
                            style="margin-left: auto;">
                                Add Comment
                            </button>
                        </div>

                        <div class="main-note mb-2"
                            v-if="project_comments.length > 0"
                            v-for="(comment, idx) in project_comments"
                            :id="'comment' + comment.id" :key="idx" :name="'comment' + comment.id"
                        >
                            <div class="arrow align-items-start">
                                <button type="button"
                                v-if="isBigThread(comment)"
                                @click="toggleCommentThread($event.target,comment)"
                                    class="focus:outline-none text-3xl font-light material-icons">
                                    {{ comment.is_expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                                </button>
                            </div>
                            <div class="note-right">
                                <div class="profile-bar">
                                    <div class="profile">
                                        <img class="prof-icon" :src="comment.created_by ? comment.created_by.photo_url : (getSafe(() => comment.causer.photo_url) )" @error="(event) => event.target.src = 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/user-image-placeholder.png'" />
                                        <span class="name">{{ comment.created_by ? comment.created_by.name : (getSafe(() => comment.causer.name) || 'System') }} |<span> {{ comment.sales_status_id ? 'Logs' : comment.sub_type }}</span></span><span v-if="comment.openai_chat_completion_id"> <span class="name">|</span> <span class="material-icons text-sm-custom text-teal p-1 text-center">auto_awesome</span> <span class="name">AI Generated</span></span>
                                        <div class="comments-count cursor-pointer" @click.prevent="expandThreadAndReplies($event.target,comment)" v-if="isBigThread(comment) && comment.replies.length">
                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.3438 6.84375V5.5H7.65625V2.84375H6.34375V5.5H3.65625V6.84375H6.34375V9.5H7.65625V6.84375H10.3438ZM13.6562 2.15625V14.1562L11 11.5H1.65625C1.30208 11.5 0.989583 11.3646 0.71875 11.0938C0.46875 10.8229 0.34375 10.5104 0.34375 10.1562V2.15625C0.34375 1.80208 0.46875 1.5 0.71875 1.25C0.989583 0.979167 1.30208 0.84375 1.65625 0.84375H12.3438C12.6979 0.84375 13 0.979167 13.25 1.25C13.5208 1.5 13.6562 1.80208 13.6562 2.15625Z"
                                                    fill="#3D4852" />
                                            </svg>
                                            <span class="count">{{ comment.replies.length }}</span>
                                        </div>
                                    </div>

                                    <div class="options">
                                        <div class="date d-none d-md-block">
                                            <span>{{ commentTime((comment.hasOwnProperty('email_timestamp') && comment.email_timestamp != null) ? comment.email_timestamp : comment.updated_at)}}</span>
                                        </div>
                                        <div class="ico" v-if="comment.sub_type== 'Comment' && !comment.sales_status_id && ( comment.created_by_id == user.id || isAdmin) " @click="showEditCommentBox(comment)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 25" fill="none">
                                                <path
                                                    d="M11 3.5H5C3.89543 3.5 3 4.39543 3 5.5V19.5C3 20.6046 3.89543 21.5 5 21.5H19C20.1046 21.5 21 20.6046 21 19.5V13.5"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path
                                                    d="M9.5 12.0002L17.5 4.00023C18.3284 3.1718 19.6716 3.1718 20.5 4.00023C21.3284 4.82866 21.3284 6.1718 20.5 7.00023L12.5 15.0002L8 16.5002L9.5 12.0002Z"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <!-- <div class="ico">
                                            <button type="button" v-if="!comment.watch_email && canEdit"  @click.prevent.stop="addWatchEmailComment(comment)"
                                                    class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons hidden md:inline">
                                                visibility
                                            </button>
                                            <button type="button" v-else-if="canEdit" @click.prevent.stop="removeWatchEmailComment(comment)"
                                                    class="focus:outline-none text-base font-light text-success material-icons hidden md:inline">
                                                visibility
                                            </button>
                                        </div> -->
                                        <div class="ico">
                                            <button type="button" v-if="!comment.pinned && canEdit" @click.prevent.stop="addPinComment(comment)"
                                                    class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons hidden md:inline">
                                                push_pin
                                            </button>
                                            <button type="button" v-else-if="canEdit" @click.prevent.stop="removePinComment(comment)"
                                                    class="focus:outline-none text-base font-light text-danger material-icons hidden md:inline">
                                                push_pin
                                            </button>
                                        </div>
                                        <div class="ico" v-if="(comment.sub_type == 'Comment' && !comment.sales_status_id && comment.created_by_id == user.id) || (comment.sub_type == 'Email' && isAdmin)">
                                            <button type="button" v-if="canEdit" @click.prevent.stop="removeComment(comment, idx)"
                                                    class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons md:inline">
                                                delete
                                            </button>
                                        </div>

                                    </div>

                                </div>
                                <div class="note-content" :id="'comment_content' + comment.id" v-if="!comment.is_expanded && isBigThread(comment) && !comment.is_editing" v-html="getShortText(comment.comment)"></div>
                                <div class="note-content" :id="'comment_content' + comment.id" v-else-if="!comment.is_editing" v-html="comment.comment"></div>
                                <div class="note-content" :id="'comment_content' + comment.id" v-if="!comment.is_editing && deadReasonCustomField && comment.dead_reason"><span><strong>{{ deadReasonCustomField.label_value ? deadReasonCustomField.label_value : '' }}:</strong> {{ comment.dead_reason }}</span></div>
                                <div class="note-content-edit" v-if="comment.is_editing && comment.sub_type== 'Comment' && (comment.created_by_id == user.id || isAdmin)" :id="'comment_edit_box' + comment.id">
                                    <ckeditor-container placeholder="Send your colleagues on FollowUp notifications by typing @ followed by their name" :key="idx" v-model="comment.editingForm.comment" :options="users" @mention="addMentionInline(comment, $event)" mentionFrom="name"></ckeditor-container>
                                    <div class="p-2 py-4">
                                        <button @click.prevent="projectCommentUpdateInline(comment,$event.target)" :class="{'dirtySaveBtn' : comment.comment == comment.editingForm.comment}" class="py-2 px-3 border-1 bg-followup-nav hover:bg-followup-nav-darker hover:text-white text-white rounded-full focus:outline-none">Save</button>
                                        <button @click.prevent="closeEditCommentBox(comment)" class="ml-2 py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">Cancel</button>
                                    </div>
                                </div>
                                <template v-if="!comment.show_replies">
                                    <div @click.prevent="showReplies(comment)" v-if="canEdit && ((!isBigThread(comment) && comment.replies.length == 0) || (isBigThread(comment) && comment.is_expanded & comment.replies.length == 0 ))" >
                                        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M10.3438 6.84375V5.5H7.65625V2.84375H6.34375V5.5H3.65625V6.84375H6.34375V9.5H7.65625V6.84375H10.3438ZM13.6562 2.15625V14.1562L11 11.5H1.65625C1.30208 11.5 0.989583 11.3646 0.71875 11.0938C0.46875 10.8229 0.34375 10.5104 0.34375 10.1562V2.15625C0.34375 1.80208 0.46875 1.5 0.71875 1.25C0.989583 0.979167 1.30208 0.84375 1.65625 0.84375H12.3438C12.6979 0.84375 13 0.979167 13.25 1.25C13.5208 1.5 13.6562 1.80208 13.6562 2.15625Z"
                                                fill="#3D4852" />
                                        </svg>
                                        <span class="count cursor-pointer" >Add Comment</span>
                                    </div>
                                    <div @click.prevent="showReplies(comment)" v-if="!isBigThread(comment) && comment.replies.length" class="cursor-pointer">
                                        <div class="notification-icon-msg">
                                            <div class="notification-icon-align">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2z"></path></svg>
                                                <p>{{ comment.replies.length }}</p>
                                            </div>
                                            <span class="count">Comments</span>
                                        </div>
                                    </div>
                                </template>
                                <div @click.prevent="hideReplies(comment)" v-if="comment.show_replies">
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.3438 6.84375V5.5H7.65625V2.84375H6.34375V5.5H3.65625V6.84375H6.34375V9.5H7.65625V6.84375H10.3438ZM13.6562 2.15625V14.1562L11 11.5H1.65625C1.30208 11.5 0.989583 11.3646 0.71875 11.0938C0.46875 10.8229 0.34375 10.5104 0.34375 10.1562V2.15625C0.34375 1.80208 0.46875 1.5 0.71875 1.25C0.989583 0.979167 1.30208 0.84375 1.65625 0.84375H12.3438C12.6979 0.84375 13 0.979167 13.25 1.25C13.5208 1.5 13.6562 1.80208 13.6562 2.15625Z"
                                            fill="#3D4852" />
                                    </svg>
                                    <span class="count cursor-pointer" >Hide Comments</span>
                                </div>

                                <div v-if="comment.replies.length && comment.show_replies"
                                    v-for="(reply, indx) in comment.replies" :key="indx" class="comment profile-bar replies-section" :id="'replies' + comment.id">
                                    <div class="profile">
                                        <img class="prof-icon" :src="reply.user.photo_url" @error="(event) => event.target.src = 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/user-image-placeholder.png'" />
                                    </div>

                                    <div class="flex flex-grow-1 flex-column" style="gap: 5px">
                                        <div class="flex">
                                            <div class="comment-content">
                                                <span class="name">{{ reply.user.name }}</span>
                                            </div>

                                            <div class="options">
                                                <div class="date d-none d-md-block">
                                                    <span>{{ commentTime(reply.updated_at)}}</span>
                                                </div>
                                                <template v-if="reply.user.id == user.id">
                                                    <div class="ico" @click="showEditReplyBox(reply)">
                                                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12.3125 2.6875L11.0938 3.90625L8.59375 1.40625L9.8125 0.1875C9.9375 0.0625 10.0938 0 10.2812 0C10.4688 0 10.625 0.0625 10.75 0.1875L12.3125 1.75C12.4375 1.875 12.5 2.03125 12.5 2.21875C12.5 2.40625 12.4375 2.5625 12.3125 2.6875ZM0.5 9.5L7.875 2.125L10.375 4.625L3 12H0.5V9.5Z"
                                                                fill="#3D4852" />
                                                        </svg>
                                                    </div>
                                                    <div class="ico" @click.prevent="deleteReply(comment,reply,indx)">
                                                        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M10.1562 0.65625V2H0.84375V0.65625H3.15625L3.84375 0H7.15625L7.84375 0.65625H10.1562ZM1.5 10.6562V2.65625H9.5V10.6562C9.5 11.0104 9.36458 11.3229 9.09375 11.5938C8.82292 11.8646 8.51042 12 8.15625 12H2.84375C2.48958 12 2.17708 11.8646 1.90625 11.5938C1.63542 11.3229 1.5 11.0104 1.5 10.6562Z"
                                                                fill="#3D4852" />
                                                        </svg>
                                                    </div>
                                                </template>
                                                <div v-else style="min-width: 36px;"></div>
                                            </div>

                                        </div>

                                        <div class="cmt-content" v-if="!reply.is_editing" v-html="reply.description"></div>
                                        <div class="cmt-content" v-else>
                                            <ckeditor-container placeholder="Send your colleagues on FollowUp notifications by typing @ followed by their name" v-model="reply.editingForm.description" :options="users" @mention="addMentionReplyInline(reply, $event)" mentionFrom="name"></ckeditor-container>
                                            <div class="p-2 py-4">
                                                <button @click.prevent="updateReply(reply,$event.target)" :class="{'dirtySaveBtn' : reply.description == reply.editingForm.description}" class="py-2 px-3 border-1 bg-followup-nav hover:bg-followup-nav-darker hover:text-white text-white rounded-full focus:outline-none">Save</button>
                                                <button @click.prevent="closeEditReplyBox(reply)" class="ml-2 py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">Cancel</button>
                                            </div>
                                        </div>



                                    </div>
                                </div>

                                <div v-if="comment.show_replies && canEdit" class="comment profile-bar replies-section">
                                    <div class="profile">
                                        <img class="prof-icon" :src="user.photo_url" @error="(event) => event.target.src = 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/user-image-placeholder.png'" />
                                    </div>

                                    <div class="flex flex-grow-1 flex-column" style="gap: 10px">
                                        <div class="flex">
                                            <div class="comment-content">
                                                <span class="name">{{ user.name }}</span>
                                            </div>

                                            <!-- <div class="options">
                                                <div class="date d-none d-md-block">
                                                    <span></span>
                                                </div>
                                                <div class="ico">
                                                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M12.3125 2.6875L11.0938 3.90625L8.59375 1.40625L9.8125 0.1875C9.9375 0.0625 10.0938 0 10.2812 0C10.4688 0 10.625 0.0625 10.75 0.1875L12.3125 1.75C12.4375 1.875 12.5 2.03125 12.5 2.21875C12.5 2.40625 12.4375 2.5625 12.3125 2.6875ZM0.5 9.5L7.875 2.125L10.375 4.625L3 12H0.5V9.5Z"
                                                            fill="#3D4852" />
                                                    </svg>
                                                </div>
                                                <div class="ico">
                                                    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M10.1562 0.65625V2H0.84375V0.65625H3.15625L3.84375 0H7.15625L7.84375 0.65625H10.1562ZM1.5 10.6562V2.65625H9.5V10.6562C9.5 11.0104 9.36458 11.3229 9.09375 11.5938C8.82292 11.8646 8.51042 12 8.15625 12H2.84375C2.48958 12 2.17708 11.8646 1.90625 11.5938C1.63542 11.3229 1.5 11.0104 1.5 10.6562Z"
                                                            fill="#3D4852" />
                                                    </svg>
                                                </div>
                                            </div> -->

                                        </div>

                                        <div class="cmt-content">
                                            <ckeditor-container v-model="comment.addNewReplyForm.description" placeholder="Send your colleagues on FollowUp notifications by typing @ followed by their name" :options="users" @mention="addMentionForNewReply(comment, $event)" mentionFrom="name"></ckeditor-container>
                                            <div class="p-2 py-4">
                                                <button @click.prevent="addNewReply(comment,$event.target)" :class="{'dirtySaveBtn' : comment.addNewReplyForm.description == ''}" class="py-2 px-3 border-1 bg-followup-nav hover:bg-followup-nav-darker hover:text-white text-white rounded-full focus:outline-none">Save</button>
                                            </div>
                                        </div>



                                    </div>
                                </div>

                            </div>
                        </div>

                        <div v-if="project_comments.length === 0" class="mb-2">
                            <div class="px-3 py-2 text-grey-darkest text-sm">
                                Your project does not currently have any {{ comment_type == 'all' || comment_type == 'filters' ? 'comments' : snakeCaseToWords(comment_type) }}. {{ comment_search ? 'Try changing your search text' : '' }}
                            </div>
                        </div>

                        </template>

                        <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center py-3 align-items-center main-note" style="gap:20px">
                            <div>
                                Total of {{ pagination.meta.total }} records
                            </div>

                            <b-pagination
                                @change="goToPage"
                                v-model="pagination.meta.current_page"
                                :total-rows="pagination.meta.total"
                                :per-page="pagination.meta.per_page"
                                first-text="First"
                                prev-text="Prev"
                                next-text="Next"
                                last-text="Last"
                            >
                            </b-pagination>
                        </div>


                    </div>


                    <div role="tabcard" class="tab-pane" id="project-milestones">
                        <project-milestones v-if="isPM" :project-milestones="project.pm_milestones"></project-milestones>
                        <project-milestones v-else :project-milestones="project.project_milestones"></project-milestones>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';
import VueTribute from 'vue-tribute';
import CKEditorContainer from '../shared/ckeditor-container';
import Swal from "sweetalert2";
import axios from 'axios';
import SnippetsPopover from "./snippets-popover.vue";
import DOMPurify from 'dompurify';

export default {
    name: 'project-comments',
    props: [
        'project',
        'isAdmin',
        'canEdit',
        'user',
        'isPM',
        'deadReasonCustomField',
        'teamDeadSalesStatusIds'
    ],
    components: {SnippetsPopover, Multiselect, VueTribute, CKEditorContainer},

    data() {
        return {
            users: [],
            vueTributeOptions: {
                values: (text, cb) => {
                    this.filterUsers(text, cb);
                },
                allowSpaces: true,
                lookup: 'name',
                fillAttr: 'name',
                selectClass: 'selected-mention'
            },
            page                  : 1,
            pagination            : {
                data : [],
                meta : {},
                links: {},
            },
            comment_type: 'all',
            comment_search: '',
            filters: {
                users : [],
                sales_activities: [],
                record_details : [],
                communication : [],
                integrations : [],
                others : [],
            },
            comment_loading: false,
            project_comments: [],
            selects: {},
            form: '',
            editing: false,
            projectCommentForm: new Form({
                id: null,
                comment: '',
                date: '',
                company_contact_id: null,
                sales_status_id: null,
                mentioned_users: [],
                saving: false,
                commentAddFrom:null,
                deadReason: null,
                aiChatCompletionId: null
            }),
            researchAILoader: false
        }
    },
    computed: {
        isProjectSalesStatusDead() {
            return this.teamDeadSalesStatusIds.includes(this.project.sales_status);
        }
    },
    watch: {
        'projectCommentForm.comment': function(value) {
            if(value.trim() === "") {
                this.projectCommentForm.aiChatCompletionId = null;
            }
        }
    },
    created() {
        this.fetchCodes();
        this.fetchTeamUsers();
        let commentsFilterState = this.getSafe(() => this.user.user_default_settings.project_comment_filters) || null;
        if(commentsFilterState){
            this.filters = JSON.parse(commentsFilterState);
            this.applyActivityFiltersOnComments();
        }else{
            this.fetchComments();
        }
    },

    mounted() {
        $(document).on('click', '#userFilter', function() {
            $('#userFilterDiv').show();
            $('#filtermultiselect').focus();
        });
        $(document).on('click', 'body', function() {
            var div = document.getElementById("userFilterDiv");
            var button = document.getElementById("userFilter");
            if (div && !div.contains(event.target) && !button.contains(event.target)) {
                div.style.display = "none";
            }
        });

        $(document).on('click', '#activityFilter', function() {
            $('#activityFilterDiv').show();
        });
        $(document).on('click', 'body', function() {
            var div = document.getElementById("activityFilterDiv");
            var button = document.getElementById("activityFilter");
            if (div && !div.contains(event.target) && !button.contains(event.target)) {
                div.style.display = "none";
            }
        });
        let self = this;
        $("#projectCommentModalNew").on('hidden.bs.modal', function (event) {
            if ($(event.target).attr('id') === 'projectCommentModalNew') {
                self.projectCommentForm.reset();
                self.projectCommentForm.sales_status = null;
                self.editing = false;
            }
        });
    },

    methods: {
        showEditCommentBox(comment) {
            this.project_comments.forEach(c => {
                c.is_editing = false;
            });
            comment.is_editing = true;
        },
        closeEditCommentBox(comment) {
            comment.is_editing = false;
            comment.editingForm.comment = comment.comment;
        },
        isUserSelected(user) {
            return this.filters.users.filter(u => u.id == user.id).length ? true : false;
        },
        showEditReplyBox(reply) {
            reply.is_editing = true;
        },
        closeEditReplyBox(reply) {
            reply.is_editing = false;
            reply.editingForm.description = reply.description;
        },
        snakeCaseToWords(snakeCaseString) {
            const words = snakeCaseString.split('_');
            const result = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            return result;
        },
        isBigThread(comment) {
            if (comment.is_expanded == false) {
                return true;
            }

            const words = comment.comment.split(/\s+/);
            return words.filter(word => word !== '').length > 50;
        },
        getShortText(comment) {
            return comment.split(/\s+/).slice(0, 50).join(' ') + '...';
        },
        toggleCommentThread(el,comment) {
            comment.is_expanded = !comment.is_expanded;
            comment.show_replies = false
        },
        expandThreadAndReplies(el,comment) {
            comment.is_expanded = true;
            comment.show_replies = true;
        },
        showReplies(comment) {
            comment.show_replies = true;
        },
        hideReplies(comment) {
            comment.show_replies = false;
        },
        addMentionInline(comment,replaced) {

            let mentionedUserId = replaced.pivot ? replaced.pivot.user_id : replaced.id;

            if (!mentionedUserId || _.find(comment.editingForm.mentioned_users, o => o === mentionedUserId)) {
                return;
            }
            comment.editingForm.mentioned_users.push(mentionedUserId);
        },
        addMentionReplyInline(reply,replaced) {

            let mentionedUserId = replaced.pivot ? replaced.pivot.user_id : replaced.id;

            if (!mentionedUserId || _.find(reply.editingForm.mentioned_users, o => o === mentionedUserId)) {
                return;
            }
            reply.editingForm.mentioned_users.push(mentionedUserId);
        },
        addMentionForNewReply(comment,replaced) {

            let mentionedUserId = replaced.pivot ? replaced.pivot.user_id : replaced.id;

            if (!mentionedUserId || _.find(comment.addNewReplyForm.mentioned_users, o => o === mentionedUserId)) {
                return;
            }
            comment.addNewReplyForm.mentioned_users.push(mentionedUserId);
        },
        projectCommentUpdateInline(comment,el) {
            $(el).addClass('inline-loader');
            comment.editingForm.put(route('api.project-comment.update', {projectComment: comment.id})).then((res) => {
                $(el).removeClass('inline-loader');
                comment.comment = comment.editingForm.comment;
                comment.updated_at = res.comment.updated_at;
                this.closeEditCommentBox(comment);
                // this.project_comments = this.formatCommentResponse(res.data);
                this.getToast().fire({
                    type: "success",
                    title: "Updated Successfully"
                });
            });
        },
        formatCommentResponse(data) {
            return data.map(comment => {
                    comment.comment = this.formatEditComment(comment);
                    comment.is_expanded = true;
                    comment.show_replies = false;
                    comment.is_editing = false;
                    comment.addNewReplyForm = new Form({
                        comment_id: comment.id,
                        type: comment.type,
                        description: '',
                        mentioned_users: [],
                    });
                    comment.editingForm = new Form({
                        id: comment.id,
                        comment: comment.comment,
                        date: comment.created_at,
                        company_contact_id: comment.company_contact_id,
                        sales_status_id: comment.sales_status_id,
                        mentioned_users: [],
                        saving: false,
                        commentAddFrom:null
                    });
                    comment.replies = this.formatRepliesResponse(comment.replies);

                    return comment;
                });
        },
        formatRepliesResponse(data) {
            return data.map(reply => {
                    reply.is_editing = false,
                    reply.editingForm = new Form({
                        id: reply.id,
                        description: reply.description ? reply.description.replace(/\n/g, '<br />') : '',
                        mentioned_users: [],
                    });

                    return reply;
                });
        },
        addNewReply(comment,el) {
            if(!comment.addNewReplyForm.description) return false;

            $(el).addClass('inline-loader');
            comment.addNewReplyForm.post(route('api.project-comment-reply.store', {project: this.project.id,page_type: this.comment_type, page: this.page})).then((res) => {
                let formatedReply = this.formatRepliesResponse([res.reply]);
                comment.replies.push(formatedReply[0]);

                comment.addNewReplyForm.description = '';

                $(el).removeClass('inline-loader');
                this.getToast().fire({
                    type: "success",
                    title: "Comment Added"
                });
            });

        },
        updateReply(reply,el) {
            if(!reply.editingForm.description) return false;

            $(el).addClass('inline-loader');
            reply.editingForm.put(route('api.project-comment-reply.update', {projectCommentReply: reply.id})).then((res) => {
                $(el).removeClass('inline-loader');

                reply.is_editing = false;
                reply.updated_at = new Date();
                reply.description = reply.editingForm.description;

                this.getToast().fire({
                    type: "success",
                    title: "Comment Updated"
                });

                // this.fetchComments();
            });

        },
        deleteReply(comment,reply, idx) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Swal.fire({
                title: "Are you sure?",
                text: "Are you sure you want to delete this comment?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('api.project-comment-reply.delete', {projectCommentReply: reply.id})).then(() => {
                        comment.replies.splice(idx, 1);

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        Toast.fire({
                            type: "success",
                            title: "Your comment has been deleted."
                        });

                        // this.fetchComments();
                    });
                }
            });
        },
        searchComments() {
            // if(!this.comment_search) return false;
            $('#project_comments_tab').addClass('active');
            $('#project-milestones').removeClass('active');
            this.page = 1;
            this.comment_type = 'all';
            this.fetchComments();
        },
        applyUserFilterOnComments() {
            // if(!this.filters.users.length) return false;
            this.page = 1;
            this.fetchComments();
        },
        applyActivityFiltersOnComments() {
            this.comment_type = 'filters';
            this.page = 1;
            this.fetchComments();
        },
        selectAllActivitiesFilter() {
            if (this.$refs.allActivityCheckbox.checked) {
                this.filters.sales_activities = this.selects.sales_activities.map(u => u.id);
                this.filters.record_details = ['base_bid','base_bid_total','contract_amount','contract_amount_total','estimated_contract_date','contract_date','login_date','gross_margin_percentage','labor_hours','dead_date','complete_percentage'];
                this.filters.communication = ['email','comment'];
                this.filters.others = ['project_info','project_data'];
                // this.filters.others = ['project_info','change_order','project_data'];
                this.$refs.salesActivityCheckbox.checked =true;
                this.$refs.recordDetailCheckbox.checked =true;
                this.$refs.communicationCheckbox.checked =true;
                this.$refs.othersCheckbox.checked =true;
            }else{
                this.filters.sales_activities = [];
                this.filters.record_details = [];
                this.filters.communication = [];
                this.filters.others = [];
                this.$refs.salesActivityCheckbox.checked =false;
                this.$refs.recordDetailCheckbox.checked =false;
                this.$refs.communicationCheckbox.checked =false;
                this.$refs.othersCheckbox.checked =false;
            }
        },
        selectAllSalesActivityFilter() {
            if (this.$refs.salesActivityCheckbox.checked) {
                this.filters.sales_activities = this.selects.sales_activities.map(u => u.id);
            }else{
                this.filters.sales_activities = [];
            }
        },
        selectAllRecordDetailsFilter() {
            if (this.$refs.recordDetailCheckbox.checked) {
                this.filters.record_details = ['base_bid','base_bid_total','contract_amount','contract_amount_total','estimated_contract_date','contract_date','login_date','gross_margin_percentage','labor_hours','dead_date','complete_percentage'];
            }else{
                this.filters.record_details = [];
            }
        },
        selectAllCommunicationFilter() {
            if (this.$refs.communicationCheckbox.checked) {
                this.filters.communication = ['email','comment'];
            }else{
                this.filters.communication = [];
            }
        },
        selectAllOthersFilter() {
            if (this.$refs.othersCheckbox.checked) {
                this.filters.others = ['project_info','project_data'];
                // this.filters.others = ['project_info','change_order','project_data'];
            }else{
                this.filters.others = [];
            }
        },
        fetchCommentsBy(type) {
            this.page = 1;
            this.comment_type = type;
            this.comment_search = '';
            this.filters = {
                users : [],
                sales_activities: [],
                record_details : [],
                communication : [],
                integrations : [],
                others : [],
            },
            this.fetchComments();
        },

        formatEditComment(commentData) {
            let comment = commentData.comment;
            let emailId = commentData.email_id;
            let emailTimestamp = commentData.email_timestamp;

            if(emailId && emailTimestamp && !comment.includes('Date:') && !comment.includes('Date and Time:')) {
                comment = 'Date: ' + this.externalEmailTimestampFormat(emailTimestamp) + '\r\n' + comment;
            }

            if(comment && comment !== '') {
                comment = comment.replace(/\n/g, '<br />');
            }

            if(emailId && comment && comment !== '') {
                let count = 0;
                comment = DOMPurify.sanitize(comment);
                comment = comment.replace(/(<br\s*\/?>\s*)+/gi, (match) => {
                    count++;
                    console.log(`Match ${count}:`, match);
                    return count > 5 ? '' : match;
                });
            }
            return comment;
        },


        fetchTeamUsers() {
            axios.get(route('api.team-users')).then(({data}) => {
                this.users = data.filter((m) => (m.pivot.active && m.is_registered));
            })
        },


        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = data;
                this.usersForContact = this.selects.users;
            });
        },

        goToPage(page) {
            this.page = page;
            this.fetchComments();
        },

        fetchComments() {
            this.comment_loading = true;
            axios.get(route('api.project-comment.index', {
                project: this.project.id,
                type: this.comment_type,
                search: this.comment_search,
                filterByUsers: this.filters.users.map(u => u.id),
                filterBySalesActivities: this.filters.sales_activities,
                filterByCommunication: this.filters.communication,
                filterByRecordDetails: this.filters.record_details,
                filterByOthers: this.filters.others,
                commentPage: this.page
            })).then(({data}) => {

                this.project_comments = this.formatCommentResponse(data.data);
                // this.page = data.meta.current_page;
                this.pagination = data;
                this.comment_loading = false;
            });
        },


        projectCommentSaved() {
            let self = this;
            if(self.isProjectSalesStatusDead && self.deadReasonCustomField) {
                self.projectCommentForm.sales_status_id = self.project.sales_status;
            }

            self.projectCommentForm.post(route('api.project-comment.store', {project: self.project.id})).then((res) => {
                self.projectCommentForm.saving = false;
                $("#projectCommentModalNew").modal("hide");
                this.fetchCommentsBy('comment');

                window.analytics.track('Project Comments', {
                    projectName: self.project.name,
                    timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                    userName: self.user.name,
                    userEmail: self.user.email,
                    comment: self.projectCommentForm.comment,
                    team: this.spark.state.currentTeam.name
                });
            });
        }
        ,

        addComment(contact = null) {
            $("#projectCommentModalNew").modal("show");
            this.projectCommentForm.reset();
        }
        ,

        editComment(comment) {
            $("#projectCommentModalNew").modal("show");
            comment.comment = this.formatEditComment(comment)
            this.editing = true;
            Object.assign(this.projectCommentForm, comment);
        }
        ,

        addPinComment(comment) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to pin this comment?",
                icon: "warning",
                buttons: true,
                dangerMode: false,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.put(route('api.project-comment.add-pin', {projectComment: comment.id, type: comment.type})).then(({data}) => {

                    // this.project_comments = this.formatCommentResponse(data.data);
                    this.page = 1;
                    this.fetchComments();

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        Toast.fire({
                            type: "success",
                            title: "Your comment has been pinned."
                        });
                    });
                }
            });
        }
        ,

        removePinComment(comment) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to remove pin?",
                icon: "warning",
                buttons: true,
                dangerMode: false,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.put(route('api.project-comment.remove-pin', {projectComment: comment.id, type: comment.type})).then(({data}) => {

                        // this.project_comments = this.formatCommentResponse(data.data);
                        this.page = 1;
                        this.fetchComments();

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        Toast.fire({
                            type: "success",
                            title: "Pin has removed."
                        });
                    });
                }
            });
        }
        ,
        addWatchEmailComment(comment) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to watch this comment?",
                icon: "warning",
                buttons: true,
                dangerMode: false,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.put(route('api.project-comment.add-watch-email', {projectComment: comment.id})).then(({data}) => {

                        self.project_comments = data.data;

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        Toast.fire({
                            type: "success",
                            title: "Your comment has been watched."
                        });
                    });
                }
            });
        }
        ,

        removeWatchEmailComment(comment) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to remove Watch Comment?",
                icon: "warning",
                buttons: true,
                dangerMode: false,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.put(route('api.project-comment.remove-watch-email', {projectComment: comment.id})).then(({data}) => {

                        self.project_comments = data.data;

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        Toast.fire({
                            type: "success",
                            title: "Watch comment has removed."
                        });
                    });
                }
            });
        }
        ,

        removeComment(comment, idx) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            let self = this;
            Swal.fire({
                title: "Are you sure?",
                text: "Are you sure you want to delete this comment?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('api.project-comment.delete', {projectComment: comment.id})).then(() => {
                        self.project_comments.splice(idx, 1);

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        Toast.fire({
                            type: "success",
                            title: "Your comment has been deleted."
                        });

                        // this.fetchComments();
                    });
                }
            });
        }
        ,

        addMention(replaced) {
            let mentionedUserId = replaced.pivot ? replaced.pivot.user_id : replaced.id;
            if (_.find(this.projectCommentForm.mentioned_users, o => o === mentionedUserId)) {
                return;
            }
            this.projectCommentForm.mentioned_users.push(mentionedUserId);
        }
        ,

        filterUsers(mentionText, cb) {
            const users = _.filter(this.users, (user) => user.name.indexOf(mentionText) !== -1);
            cb(users.slice(0, 5));
        }
        ,

        formatCommentView(comment) {
            let text = comment.comment.replace(/\n/g, '<br>');
            let emailId = comment.email_id;
            let emailTimestamp = comment.email_timestamp;

            if(emailId && emailTimestamp && !text.includes('Date:') && !text.includes('Date and Time:')) {
                text = 'Date: ' + this.externalEmailTimestampFormat(emailTimestamp) + '\r\n' + text;
            }
            if (text.split('From:').length > 2) {
                return `From: ${text.split('From:')[1].trim()}`;
            }
            return text;
        }
        ,
        commentTime(commentTime) {
            return moment.utc(commentTime).local().format('L [at] LT');
        },
        externalEmailTimestampFormat(timestamp) {
            return moment.utc(timestamp).local().format('L LT');
        },
        closeProjectCommentModal() {
            let self = this;
            $("#projectCommentModal").modal("hide");
            self.commentAddFrom = null;
            self.projectCommentForm.commentAddFrom = null;
        },
        insertSnippet(data){
            if(data){
                this.projectCommentForm.comment = this.projectCommentForm.comment +''+ data;
            }
        },
        openAIProjectSummaryInfo() {
            let self = this;
            self.researchAILoader = true;

            axios.post(route('api.openai.project-summary-info', {projectId: self.project.id})).then((response) => {
                self.projectCommentForm.aiChatCompletionId = response.data.chatCompletionId;
                self.projectCommentForm.comment = response.data.content;
                self.researchAILoader = false;
            }).catch((error) => {
                self.researchAILoader = false;
            });
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
    .search-history {
        margin-left: auto;
        width: 265px;
        height: 33px;
        padding: 0 18px 0 5px;
        border-radius: 5px;
        border: 1px solid #ced4da;
        background: #fff;
    }
    .activetab{
        text-decoration: underline;
    }

    .top-bar {
        gap: 25px;
    }

    .main-note {
        display: flex;
        flex-flow: row nowrap;
        border-radius: 4px;
        background: #FFF;
        padding: 25px 10px;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.12);
        font-family: Whitney, Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";

        .ck-rounded-corners{
            filter: drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.12));
            font-size: 15px !important;
        }
        .ck-editor__editable{
            background: #F5F5F5 !important;
        }
    }

    .main-note .note-right {
        display: flex;
        flex-flow: column nowrap;
        gap: 10px;
        flex-grow: 100;
    }

    .main-note .profile-bar {
        display: flex;
        /* height: 67px; */
        padding-right: 0px;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
        flex-flow: row nowrap;
        gap: 10px;
    }

    .main-note .profile {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .main-note .arrow {
        display: flex;
        padding: 10px 15px 10px 5px;
        min-width: 50px;
    }

    .main-note .prof-icon {
        width: 47px;
        height: 47px;
        border-radius: 30px;
        /* margin-left: -25px; */
    }

    .main-note .name {
        color: #3D4852;
        font-size: 15px;
        font-style: normal;
        line-height: 17.5px;
    }

    .main-note .name span {
        color: #3D4852;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 17.5px;
    }

    .main-note .comments-count {
        display: flex;
        width: 48px;
        height: 18px;
        align-items: flex-end;
        gap: 6px;
    }

    .main-note .count {
        color: #3D4852;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 17.5px;
    }

    .main-note .options {
        display: flex;
        padding-left: 0px;
        justify-content: flex-end;
        align-items: center;
        gap: 12px;
    }

    .main-note .options .date {
        display: flex;
        /* padding: 10px;
        align-items: flex-start;
        gap: 10px; */
    }

    .main-note .options span {
        color: #3D4852;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 17.5px;
    }

    .main-note .options .ico {
        display: flex;
        cursor: pointer;
        /* padding: 10px;
        align-items: flex-start;
        gap: 10px; */
    }

    .main-note .note-content, .main-note .note-content-edit {
        color: #3D4852;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 17.5px;
        width: 90%;
        display: flex;
        overflow-wrap: anywhere;
        flex-flow: column wrap;
    }

    .commentBtn {
        margin-left: auto;
        border-radius: 20px;
        border: 1px solid #01B1AF;
        background: #FFF;
        padding: 0 12px;

        color: #01B1AF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 18.4px;

        &:hover {
            background-color: #01b1af;
            color: white;
        }
    }

    .comment.profile-bar {
        justify-content: flex-start;
        margin-right: 100px;
        align-items: flex-start;

        .prof-icon {
            width: 35px;
            height: 35px;
        }

        .profile {
            align-items: flex-start;
            flex-shrink: 0;
        }

        .name {
            font-size: 14px;
        }

        .options {
            margin-left: auto;
        }

        .comment-content {
            display: flex;
            flex-flow: column wrap;
            margin-top: 8px;
        }

        .cmt-content {
            color: #3D4852;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 17.5px;
            display: flex;
            flex-flow: column wrap;
        }
    }

    .model_loader{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        display: none;
        background: rgb(0 0 0 / 57%);
    }
    .model_loader .model_spinner{
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .truncateText3{
        display: -webkit-box !important;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .ck-editor__editable {
        max-height: 100% !important;
    }
    .ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
        border-color: var(--ck-color-base-border);
    }
    .dirtySaveBtn{
        background-color: #999999;
        pointer-events: none;

        &:hover {
            background-color: #999999;
            pointer-events: none;
        }
    }
    .main-note .ck-content .mention, .main-note .mention {
        background: rgb(1 177 175);
        color: #ffffff;
        padding: 1px 4px;
        user-select: text;
    }
    .comment_filters .multiselect__placeholder{
        display: none;
    }
    .comment_filters .multiselect__content-wrapper{
        position: relative !important;
    }

    .dropdown-container{
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 10rem;
        padding: 0.5rem 0;
        margin: 0.125rem 0 0;
        font-size: 12px;
        color: #49545a;
        text-align: left;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(55, 63, 67, .15);
        border-radius: 0.25rem;
    }




    @media (max-width: 767px) {
        .main-note .arrow {
            display: flex;
            padding: 12px 0px;
            min-width: 35px;
        }

        .main-note .note-content, .main-note .note-content-edit {
            width: 100%;
        }

        .main-note .profile {
            gap: 6px;
        }

        .comment.profile-bar {
            margin-right: 0;
        }

        .commentBtn {
            padding: 0 4px;
        }

        .top-bar {
            gap: 12px;
        }

        .truncateText3{
            display: -webkit-box !important;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .main-note {
            .profile-bar {

                .options {
                    margin-left: auto;
                }
            }
        }
        .cmt-content .ck-editor.ck-rounded-corners{
            width: 250px;
        }


    }
    .MsoNormal img[src="https://app.followupcrm.com/images/followup-horizontal-teal.png"] {
        width: 160px !important;
        height: auto !important;
    }
    .MsoNormal:has(img[src="https://app.followupcrm.com/images/followup-horizontal-teal.png"]) {
        display: inline-flex;
        align-items: center;
        font-weight: bold; padding: 0 15px; font-family: sans-serif; border-radius: 10px; background-color: #e6e6e6;
    }
</style>

<style scoped>
.notification-icon-msg svg {
    transform: scaleX(-1);
}

.notification-icon-align {
    position: relative;
    width: fit-content;
}

.notification-icon-msg {
    display: flex;
    align-items: center;
}

.notification-icon-msg .count {
    margin-left: 4px;
    font-size: 13px !important;
}

.notification-icon-align p {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: #000;
    bottom: 4px;
}

.notification-icon-msg svg path {
    fill: #3cb1ae;
}

.text-sm-custom {
    font-size: .900rem;
}
</style>
